module.exports = __webpack_public_path__ + "img/live_selected.d93a0f85.png";